import React from 'react'
import { Outlet } from 'react-router-dom'

const Orders = () => {
  return (
    <div><Outlet /></div>
  )
}

export default Orders